import React from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Table, } from 'react-bootstrap';
import moment from 'moment-timezone';
import IconAlert from 'components/common/IconAlert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubtleBadge from 'components/common/SubtleBadge';
import nl2br from 'react-nl2br';

const OneDPSoneDemande = ({
    index,
    demande,
}) => {
    return (<>
        <Accordion.Item eventKey={index} flush="true">
            <Accordion.Header>
                Détails de la demande #{index}
                {!demande.demandeIsClosed ?
                    <SubtleBadge className='ms-3' bg='warning'>INCOMPLETE</SubtleBadge>
                :
                    <SubtleBadge className='ms-3'>Soumise le {moment(demande.dateFinalisationDemande).format('DD/MM/YYYY HH:mm')}</SubtleBadge>
                }
            </Accordion.Header>
            <Accordion.Body>
                {!demande.demandeIsClosed ?
                    <IconAlert variant={'warning'}>
                        Cette demande n'est pas complète ! <Link to={"/demandeDPS/"+demande.demandeUpdateCode}>Terminez de la soumettre au plus vite !</Link>
                    </IconAlert>
                :
                    <>
                        <Table bordered size='sm'>
                            <tbody>
                                <tr key={'ligne1'}>
                                    <th rowSpan={4} style={{ width: '1%', writingMode: 'sideways-lr', textAlign: 'center' }}>ORGANISATION</th>
                                </tr>
                                <tr key={'ligne2'}>
                                    
                                    <th>Organisateur</th>
                                    <td>
                                        Raison sociale: {demande.orgaRaisonSociale}<br/>
                                        Adresse: {demande.orgaAdresse}<br/>
                                        Représentant légal: {demande.orgaRepresentantLegal} - {demande.orgaRepresentantLegalFonction} - {demande.orgaRepresentantLegalMail} - {demande.orgaRepresentantLegalTel}<br/>
                                        Facturation: {demande.orgaFacturationMail} - {demande.orgaFacturationTel}
                                    </td>
                                </tr>

                                <tr key={'ligne3'}>
                                    <th style={{ width: '25%' }}>Dossier suivi par</th>
                                    <td>
                                        Identité: {demande.orgaRepresentePar}<br/>
                                        Fonction: {demande.orgaRepresenteParFonction}<br/>
                                        Mail: {demande.orgaRepresenteParMail}<br/>
                                        Téléphone: {demande.orgaRepresenteParTel}
                                    </td>
                                </tr>

                                <tr key={'ligne4'}>
                                    <th>Contact sur place le jour J</th>
                                    <td>
                                        Identité: {demande.orgaContactLocal}<br/>
                                        Fonction: {demande.orgaContactLocalFonction}<br/>
                                        Téléphone: {demande.orgaContactLocalTel}
                                    </td>
                                </tr>


                                <tr key={'ligne5'}>
                                    <th rowSpan={8} style={{ width: '1%', writingMode: 'sideways-lr', textAlign: 'center' }}>EVENEMENT</th>
                                </tr>
                                <tr key={'ligne6'}>
                                    <th style={{ width: '25%' }}>Evenement</th>
                                    <td>{demande.libelleEvenement}</td>
                                </tr>
                                <tr key={'ligne7'}>
                                    <th>Activité</th>
                                    <td>{demande.activiteEvenement}</td>
                                </tr>
                                <tr key={'ligne8'}>
                                    <th>Date</th>
                                    <td>{moment(demande.dateDebutEvenement).format('dddd DD MMMM YYYY')}</td>
                                </tr>
            
                                <tr key={'ligne9'}>
                                    <th>Lieu de l'évènement</th>
                                    <td>
                                        {demande.manifNomLieu}<br/>
                                        {demande.manifAdresse}<br/>
                                        {demande.manifCP} {demande.manifVille}<br/>
                                        {demande.manifInternational ? <SubtleBadge bg='warning'>ASPECT INTERNATIONAL</SubtleBadge> : <SubtleBadge bg='secondary'>En France uniquement</SubtleBadge>}
                                    </td>
                                </tr>
            
                                <tr key={'ligne10'}>
                                    <th>Caractéristiques du lieu</th>
                                    <td>
                                        Sur voie publique: {demande.manifSurVP ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Voie publique fermée à la circulation: {demande.manifSurVPFermee ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Sur circuit: {demande.manifCircuit ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Circuit entièrement carrossable: {demande.manifCircuitCarrossable ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Score E1 d'accessibilité (calculé): {demande.manifE1Accessibilite}<br/>
                                        Score E2 secours publics (calculé): {demande.manifE2DelaisSP}<br/>
                                        Pompiers de proximité: {demande.manifSPproches}<br/>
                                        Centre hospitalier de proximité: {demande.manifCHUproches}<br/>
                                        Risques particuliers: {nl2br(demande.manifRisqueSite)}<br/>
                                        Remarques: {nl2br(demande.manifRemarques)}
                                    </td>
                                </tr>
            
                                <tr key={'ligne11'}>
                                    <th>Autres services sur place</th>
                                    <td>
                                        Autre AASC: {demande.accueilAutreAASC ? demande.accueilAutreAASCDetails : <FontAwesomeIcon icon='close'/>}<br/>
                                        SME: {demande.accueilSME ? demande.accueilSMEDetails : <FontAwesomeIcon icon='close'/>}<br/>
                                        Médical hors SME: {demande.accueilMedicalAutreSME ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Ambulance privée: {demande.accueilAP ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        SAMU: {demande.accueilSAMU ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Pompiers: {demande.accueilSP ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Sécurité Privée: {demande.accueilSecuPrivee ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Forces de l'ordre: {demande.accueilFDO ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}
                                    </td>
                                </tr>
            
                                <tr key={'ligne12'}>
                                    <th>Conditions d'accueil</th>
                                    <td>
                                        Radio fournie: {demande.accueilRadioOrga ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Locaux en dur dédiés aux Postes de Secours: {demande.accueilLocauxIS ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Tentes dédiées aux Postes de Secours: {demande.accueilTenteIS ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Electricité: {demande.accueilElectricite ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Eau courante: {demande.accueilEau ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Chauffage/Climatisation: {demande.accueilChauffage ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Lumière: {demande.accueilLumiere ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Mobilier à disposition: {nl2br(demande.accueilMobilierIS)}<br/>
                                        Repas fournis: {demande.accueilRepas ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Eau pour plans forte chaleur: {demande.accueilEauCanicule ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                        Local repos secouristes: {demande.accueilReposIS ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}
                                    </td>
                                </tr>

                                {demande.parties.map((partie, i)=>{return(
                                    <>
                                        <tr key={'ligne13'}>
                                            <th rowSpan={6} style={{ width: '1%', writingMode: 'sideways-lr', textAlign: 'center' }}>PARTIE {i+1}</th>
                                        </tr>
                                        <tr key={'ligne14'}>
                                            <th style={{ width: '25%' }}>Horaires de l'évènement</th>
                                            <td>
                                                Début: {moment(partie.dateDebutPartieEvenement).format("DD/MM/YYYY HH:mm")}<br/>
                                                Fin: {moment(partie.dateFinPartieEvenement).format("DD/MM/YYYY HH:mm")}
                                            </td>
                                        </tr>
                                        <tr key={'ligne15'}>
                                            <th>Horaires de présence des secouristes</th>
                                            <td>
                                                Début: {moment(partie.dateDebutPartieSecours).format("DD/MM/YYYY HH:mm")}<br/>
                                                Fin: {moment(partie.dateFinPartieSecours).format("DD/MM/YYYY HH:mm")}
                                            </td>
                                        </tr>
                                        <tr key={'ligne16'}>
                                            <th>Public</th>
                                            <td>
                                                Effectif attendu: {partie.effectifPublicP1}<br/>
                                                Score P2 comportement public (calculé): {partie.typePublicP2}<br/>
                                                Vente Alcool: {partie.venteAlcool ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                                Risques particuliers: {nl2br(partie.risquesPublic)}
                                            </td>
                                        </tr>
                                        <tr key={'ligne17'}>
                                            <th>Acteurs</th>
                                            <td>
                                                Effectif attendu: {partie.effectifActeurs}<br/>
                                                Activité: {partie.activiteActeurs}<br/>
                                                Risques particuliers: {nl2br(partie.risquesActeurs)}
                                            </td>
                                        </tr>
                                        <tr key={'ligne18'}>
                                            <th>Autres risques</th>
                                            <td>
                                                Pyrotechnie: {partie.pyrotechnie ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                                Engins motorisés: {partie.enginsMotrises ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}
                                            </td>
                                        </tr>
                                    </>
                                )})}
                            </tbody>
                        </Table>
                    </>
                }
            </Accordion.Body>
        </Accordion.Item>
    </>);
    
};

OneDPSoneDemande.propTypes = {};

export default OneDPSoneDemande;
